import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ChevronUpIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M2.156 16.863a.5.5 0 0 1-.018-.707l9.5-10a.5.5 0 0 1 .725 0l9.5 10a.5.5 0 0 1-.726.688L12 7.226l-9.137 9.618a.5.5 0 0 1-.707.018Z" />
  </IconWrapper>
)

export default ChevronUpIconMedium
